interface IProps {
  headers: string[];
  data: any[];
  className?: string;
  style?: React.CSSProperties;
}

const TableComponent: React.FC<IProps> = (props: IProps) => {
  return (
    <div className="table-responsive">
      <table className={"table " + (props.className)} style={props.style}>
        <thead className="thead-light">
          <tr>
            {props.headers.map((header, index) => (
              <th scope="col" key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.data.map((row, index) => (
            <tr key={index}>
              {props.headers.map((header, index) => (
                <td key={index}>{row[header.toLocaleLowerCase()]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
